
import { Component, Vue } from 'nuxt-property-decorator'

@Component({})
export default class ClearLayout extends Vue {}
